import React from "react";
import carImage from "../assets/blue-car.png";
import "./StartupRequirements.css";

const requirements = [
 {
  id: 1,
  icon: "🧼",
  text: "Automated car washing with quick turnaround, ideal for those searching car wash partnership near me opportunities",
},
{
  id: 2,
  icon: "🛋️",
  text: "Interior detailing and deep cleaning as part of scalable car wash partnership near me business models",
},
{
  id: 3,
  icon: "🛡️",
  text: "Ceramic, graphene, or borophene coating services for premium car wash partnership near me setups",
},
{
  id: 4,
  icon: "🎯",
  text: "Paint Protection Film (PPF) installation to enhance value in car wash partnership near me services",
},
{
  id: 5,
  icon: "📦",
  text: "Subscription plans and prepaid wash packages designed for growing car wash partnership near me ventures",
},
{
  id: 6,
  icon: "🧰",
  text: "Add-ons like headlight restoration, ozone disinfection, and more to expand car wash partnership near me offerings",
},
];


const StartupRequirements = () => {
  return (
    <div className="startup-container">
      {/* Left Side */}
      <div className="startup-box">
        <div className="startup-box-header"><h2>What Services Can You Offer at Your Franchise?</h2></div>
        <ul className="startup-list">
          {requirements.map((item) => (
            <li key={item.id}>
              <span className="checkmark">✔</span>{" "}
              <span className="emoji">{item.icon}</span> {item.text}
            </li>
          ))}
        </ul>
      </div>

      {/* Right Side */}
      <div className="startup-image">
        <img src={carImage} alt="Car" />
      </div>
    </div>
  );
};

export default StartupRequirements;
